export const moveBackward = (self, el) => {
  self._checkNoProcessingTask();
  const working_layer = self._getWorkingLayerThrowable();
  const working_layer_el = self._getWorkingLayerElThrowable();
  if (!working_layer.getIsChildGraphicsEl(el)) {
    throw new Error(`layer 엘리먼트의 자식 엘리먼트만 움직일 수 있습니다.`);
  }
  const prev_el = working_layer.getPrevGraphicsEl(el);
  if (prev_el == null) {
    return;
  }
  working_layer_el.removeChild(el);
  prev_el.insertAdjacentElement("beforebegin", el);
  working_layer_el.dispatchEvent(
    new CustomEvent(`@mp/sticker-editor/reorder`, {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: {
        backward_el: el,
        forward_el: prev_el,
      },
    })
  );
  self.syncSelectorWithSelection();
};
